/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NotificationsEntityMobile { 
    event_edit_or_cancel?: boolean;
    event_new_participant?: boolean;
    event_reminder?: boolean;
    event_share?: boolean;
    event_new_event_proximity?: boolean;
    group_invitation?: boolean;
    group_accept?: boolean;
    group_new_event?: boolean;
    group_new_member?: boolean;
    group_deleted?: boolean;
    chat_new_message_smatcher?: boolean;
    chat_new_message_event?: boolean;
    chat_new_message_group?: boolean;
    marketing?: boolean;
}

